class MenuService {
	static entries = [];

	static storageName = 'menu_entries';

	static initialized = false;

	static async init(lastUpdatedAt, forceUpdate = false) {
		let storage = JSON.parse(localStorage.getItem(MenuService.storageName) ?? '{}');

		if (forceUpdate || Object.keys(storage).length === 0 || storage.last_updated_at != lastUpdatedAt) {
			await MenuService.updateMenu();
		} else {
			MenuService.entries = storage.entries;
			MenuService.initialized = true;
		}
		
		MenuService.#triggerUpdateEvent();
	}

	static async updateMenu() {
		MenuService.entries = [];
		localStorage.removeItem(MenuService.storageName);

		try {
			let response = await Helpers.Ajax.get(route('api.v1.menu.index'));
			
			MenuService.entries = response.data;
			localStorage.setItem(MenuService.storageName, JSON.stringify({
				last_updated_at: response.last_updated_at,
				entries: response.data
			}));
			MenuService.initialized = true;
			MenuService.#triggerUpdateEvent();
		} catch (error) {
			console.error("Failed to update menu", error);
		}
	}

	static #triggerUpdateEvent() {
		$(document).trigger('wwdev.menu.updated');
	}

	static getEntries() {
		if (!MenuService.initialized) {
			console.warn("Menu not initialized yet. Call MenuService.init() first.");
			return [];
		}
		return MenuService.entries;
	}

	static clearCache() {
		localStorage.removeItem(MenuService.storageName);
		MenuService.entries = [];
		MenuService.initialized = false;
	}
}

export default MenuService;